import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'skeleton-play-list-min-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './play-list-min-card.component.html',
  styleUrl: './play-list-min-card.component.scss'
})
export class skeletonPlayListMinCardComponent {

}
